import { render } from "./ProductReview.vue?vue&type=template&id=4dea24e3&scoped=true"
import script from "./ProductReview.vue?vue&type=script&lang=js"
export * from "./ProductReview.vue?vue&type=script&lang=js"

import "./ProductReview.vue?vue&type=style&index=0&id=4dea24e3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dea24e3"]])

export default __exports__